module.exports = __webpack_public_path__ + "static/media/sub-12.8c131294.jpg";